/**
 * Enhanced Funnel Detail Page
 * Wraps the modular FunnelDetailPage component from the enhanced funnels module.
 * See FunnelDetail.legacy.tsx for the original basic implementation.
 */
import { FunnelDetailPage } from '../components/detail'

export default function FunnelDetail() {
  return <FunnelDetailPage />
}
